export enum NotAssociatedSteps {
  Welcome = 0,
  Timezone = 1,
  LinkGoogleAccount = 2,
  Confirm = 3,
  Congrats = 4,
  Done = 5,
}
